import { createReducer } from '@reduxjs/toolkit'

import { setApiError } from '../actions/actions'

export const initialState = null

const apiError = createReducer(initialState, {
  [setApiError]: (state, { payload }) => payload
})

export default apiError
